module.exports = __webpack_public_path__ + "static/media/withdrawal257511af6bfef07c95338f0cca2dc4d2.webp";